const dropdownSeverity = {
    paddingBottom: "3%"
}

const dropdownAlignInput = {
    textAlignLast: "left"
}

export { dropdownAlignInput, dropdownSeverity };